import moment from 'moment/moment'
import { ISO_FORMAT_DATE } from './constants'

export default function jsonDateParser(date) {
  if (!date) return null

  return moment(date, ISO_FORMAT_DATE).toDate()
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/ISODateParser.js